import { callApi, HttpMethod } from "../../../utils/httpRequest";

const sendEmployeeLoginLink = async (email, url) => {
  return await callApi({
    method: HttpMethod.POST,
    url: `${global.api}/employees/sendLoginLink`,
    body: { email, url },
  });
};

const sendFacilityLoginLink = async (email, url) => {
  return await callApi({
    method: HttpMethod.POST,
    url: `${global.api}/facilityUser/sendLoginLink`,
    body: { email, url },
  });
};

export { sendEmployeeLoginLink, sendFacilityLoginLink };
